<template>
    <div class='slider'>
        <ul>
            <li v-for="slider in sliders" :key='slider+index' >
				<div v-if='current == key'>
					<h1>{{slider.title}}</h1>
					<h1>{{slider.second}}</h1>
					<p>{{slider.description}}</p>
                    <p>{{slider.index}}</p>
				</div>
				<img :src="slider.img" alt="">
			</li>
        </ul>
        
        <ol>
            <li v-for="w in sliders" :key='w'></li>
        </ol>
        <button @click='test'>WE</button>
    </div>
</template>

<script>

export default {
    props: ['sliders'],
    data: ()=>{
        return {
            current:1,
           
        }
    },
    
   
    methods: {
        test() {
            alert(this.index)
        

            
        }

    }

  
}
</script>

<style lang="scss">
.slider {
    background: #459;
    position: relative;
    height:500px;
    width:50vw;

    div {
        position: absolute;
        z-index: 10;
        transform: translate(-50%,50%);

        h1 {
            font-size: 5em;
        }
    }

    ul {
        position: relative;
        height: 100%;
        width: 100%;
        li {
           
            
            img {
                position: absolute;
                width: 100%;
                height: 100%;
                object-fit: cover;
                object-position: top;

                & .current {
             
                z-index:10;
                }
            }


        }
        
    }
    ol {
        display: flex;
        position: absolute;
        bottom:10px;
        right:10px;
        li {
            background: #fff;
            height:20px;
            width:3px;
            margin-left:5px;
        }
    }
}
</style>